/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true */

"use strict";

require("jquery-signalR"); // defines $.signalR

var $ = require("../jquery");
var pli = require("../core");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Class "ClientBroadcastManagerSignalRConnection"
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-----------------------------------------------
function ClientBroadcastManagerSignalRConnection(config, sendMessagesCallback) {
    /// <summary></summary>
    var url = typeof config.url === "string" ? "~" + config.url : "~/ClientBroadcastManager";

    this._sendMessagesCallback = sendMessagesCallback;
    this._signalRInstance = new $.signalR(pli.resolveUrl(url));
    this._signalRInstance.data = window.location.href; // specify the appUrl so we can determine the partition.
    this._signalRInstance.received(ClientBroadcastManagerSignalRConnection.prototype._received.bind(this));
    this._signalRInstance.start(ClientBroadcastManagerSignalRConnection.prototype._started.bind(this));
}


//-----------------------------------------------
ClientBroadcastManagerSignalRConnection.prototype._dispose = function disposeClientBroadcastManagerSignalRConnection() {
    this._signalRInstance.stop();
};


//-----------------------------------------------
// Called when SignalR starts successfully.
// Initiates conversation with server
// (sending an empty message causes server
// to respond with persistent messages).
ClientBroadcastManagerSignalRConnection.prototype._started = function startClientBroadcastManagerSignalRConnection() {
    this._signalRInstance.send("In ClientBroadcastManagerSignalRConnection.prototype._started.");
};


//-----------------------------------------------
// Handles the signalR received event
ClientBroadcastManagerSignalRConnection.prototype._received = function receivedClientBroadcastManagerSignalRConnection(result) {
    this._sendMessagesCallback(JSON.parse(result));
};

module.exports = ClientBroadcastManagerSignalRConnection;




//////////////////
// WEBPACK FOOTER
// ./~/pli/clientbroadcastmanager/SignalRConnection.js
// module id = 480
// module chunks = 49